<template>
  <v-text-field
    v-bind="attrsOnDefault"
    v-model="value"
    :class="{
      'input-success': fieldMeta && fieldMeta.validated && fieldMeta.valid,
    }"
  >
    <template v-slot:append-inner v-if="fieldMeta && fieldMeta.validated">
      <v-icon
        v-if="!fieldMeta.valid"
        icon="$mdiInformationOutline"
        size="small"
      />
      <v-icon v-else icon="$mdiCheckBold" size="small" />
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type { FieldMeta } from "vee-validate";

/**
 * 入力文字数が0になった場合に空文字ではなくnullをemitするv-text-fieldのラッパーコンポーネント.
 * @see https://vuetifyjs.com/en/components/text-fields/
 */
export default defineComponent({
  name: "AppFormInput",
  inheritAttrs: false,
  props: {
    modelValue: {
      type: [String, Number] as PropType<string | number>,
      required: false,
    },
    fieldMeta: {
      type: Object as PropType<FieldMeta<unknown>>,
      required: false,
    },
  },
  emits: ["update:modelValue"],
  computed: {
    attrsOnDefault(): { [key: string]: unknown } {
      /**
       * VeeValidateのonUpdate:modelValueで値を監視しているので、他のEventをスキップ
       * （Changeイベント二回実行して,nullを空文字に変更してしまう）
       */
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { onInput, onBlur, onChange, ...others } = this.$attrs;
      return others;
    },
    value: {
      get(): unknown {
        return this.modelValue;
      },
      set(newValue: string) {
        if (newValue === "") {
          this.$emit("update:modelValue", null);
        } else {
          this.$emit("update:modelValue", newValue);
        }
      },
    },
  },
});
</script>
